<template>
  <div>
    <b-form-group
      :label="$t('forms.vm.dcNode')"
      :state="validateState('dcNode')"
    >
      <multiselect
        v-model="form.dcNode"
        :options="dcNodeList"
        track-by="id"
        label="name"
        :loading="loadingDcNode"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.vm.dcNode')"
        :show-no-results="false"
      />
    </b-form-group>

    <b-form-group :label="$t('global.type')">
      <multiselect
        v-model="form.type"
        :options="typeList"
        track-by="id"
        label="name"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="false"
        :placeholder="$t('global.type')"
        :show-no-results="false"
      />
    </b-form-group>

    <b-form-group
      :label="$t('gateways.publicNetwork')"
      :state="validateState('wan_id')"
    >
      <multiselect
        v-model="form.wan_id"
        :options="networkList"
        track-by="id"
        label="name"
        :loading="loadingNetwork"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        @search-change="getNetworks"
        :limit="3"
        :placeholder="$t('gateways.publicNetwork')"
        :show-no-results="false"
        :disabled="form.dcNode == '' || form.dcNode.id == ''"
      />
    </b-form-group>

    <b-form-group
      :label="$t('gateways.privateNetwork')"
      :state="validateState('network_id')"
    >
      <multiselect
        v-model="form.network_id"
        :options="networkList"
        track-by="id"
        label="name"
        :loading="loadingNetwork"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        @search-change="getNetworks"
        :limit="3"
        :placeholder="$t('gateways.privateNetwork')"
        :show-no-results="false"
        :disabled="form.dcNode == '' || form.dcNode.id == ''"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CreateGateway',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    selectedItem: String | Object,
  },
  data() {
    return {
      form: {
        type: { id: 'NetGateway', name: 'NetGateway' },
        dcNode: '',
        wan_id: '',
        network_id: '',
      },
      typeList: [{ id: 'NetGateway', name: 'NetGateway' }],
      dcNodeList: [],
      networkList: [],
      loadingDcNode: false,
      loadingNetwork: false,
    }
  },
  validations: {
    form: {
      dcNode: {
        required,
      },
      wan_id: {
        required,
      },
      network_id: {
        required,
      },
    },
  },
  created() {
    this.getDatacenterNodes()
  },
  methods: {
    //dcNode::begin
    getDatacenterNodes() {
      this.getDatacenterNodeList()
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            this.dcNodeList = res.data.filter(
              (f) => f.name.toLowerCase().includes('kapatılacak') == false
            )
          }
        })
        .catch(() => {
          this.dcNodeList = []
        })
    },
    getDatacenterNodeList() {
      this.loadingDcNode = true
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/datacenter-nodes?orderBy=position|ASC`)
          .then(({ data }) => {
            resolve(data)
            this.loadingDcNode = false
          })
          .catch((err) => {
            reject(err)
            this.loadingDcNode = false
          })
      })
    },
    //dcNode::end
    //network::begin
    getNetworks(search) {
      this.loadingNetwork = true

      if (search != '') {
        this.networkList = []
      }

      this.getNetworkList(search)
        .then((res) => {
          this.setNetworkList(res)
          this.loadingNetwork = false
        })
        .catch(() => {
          this.loadingNetwork = false
          this.networkList = []
        })
    },
    getNetworkList(search) {
      this.loadingNetwork = true
      return new Promise((resolve, reject) => {
        // let query = `iaas/networks/overview?datacenterNode=${this.form.dcNode.id}&position=id|desc`
        let query = `iaas/networks?datacenterNode=${this.form.dcNode.id}&position=id|desc`

        if (search && search != '') {
          query += `&name=${search}`
        }

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
            this.loadingNetwork = false
          })
          .catch((err) => {
            reject(err)
            this.loadingNetwork = false
          })
      })
    },
    setNetworkList(res) {
      if (res && res.data && res.data.length > 0) {
        this.networkList = res.data
      }
    },
    //network::end
    dcNodeChange() {
      this.networkList = []
      this.form.wan_id = ''
      this.form.network_id = ''

      if (this.form.dcNode.id && this.form.dcNode.id != '') {
        this.getNetworks('')
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        datacenter_node_id: this.form.dcNode.id,
        wan_id: this.form.wan_id.id,
        network_id: this.form.network_id.id,
      }

      if (this.selectedItem == '') this.insertOperation(params)
      else this.updateOperation(params)
    },
    insertOperation(params) {
      ApiService.post(`packetbender/netgateways`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    updateOperation(params) {
      ApiService.put(`packetbender/netgateways/${this.selectedItem.id}`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
    'form.dcNode'() {
      this.dcNodeChange()
    },
    selectedItem(newVal) {
      this.form.dcNode = ''
      this.form.wan_id = ''
      this.form.network_id = ''
      this.$v.$reset()

      // if (newVal && newVal.datacenter_node_id) {
      //   let dcNode = this.dcNodeList.find(
      //     (f) => f.id == newVal.datacenter_node_id
      //   )
      //   console.log('dcNode', dcNode)

      //   this.form.dcNode = dcNode
      // }
    },
  },
}
</script>
